import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import {
	POLICY_CARD_EXPIRED_TITLE,
	POLICY_CARD_PRE_ISSUED_TITLE,
	POLICY_CARD_TITLE,
} from './constants';

export const PolicyDataCard = ({ data }: any) => {
	const onRiskPolicies = parseInt(data.count_policies_on_risk, 10) || 0;
	const preIssuedPolicies = parseInt(data.count_policies_pre_issued, 10) || 0;
	const expiredPolicies = parseInt(data.count_policies_expired, 10) || 0;

	return (
		<Card sx={{ width: { xs: 'auto', sm: 1 / 3 } }}>
			<CardContent>
				<Grid container justifyContent='space-between' spacing={3}>
					<Grid item style={{ width: '100%' }}>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography gutterBottom variant='subtitle1'>
								{POLICY_CARD_TITLE}
							</Typography>
							<Typography gutterBottom variant='subtitle1'>
								{onRiskPolicies.toLocaleString()}
							</Typography>
						</Box>
						<Box
							mt={2}
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography variant='subtitle2' color='textSecondary'>
								{POLICY_CARD_PRE_ISSUED_TITLE}
							</Typography>
							<Typography color='textSecondary' variant='subtitle2'>
								{preIssuedPolicies.toLocaleString()}
							</Typography>
						</Box>
						<Box
							mt={2}
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography variant='subtitle2' color='textSecondary'>
								{POLICY_CARD_EXPIRED_TITLE}
							</Typography>
							<Typography color='textSecondary' variant='subtitle2'>
								{expiredPolicies.toLocaleString()}
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};
